import { cn } from "@/lib/utils";
import {
  Circle,
  CircleCheck,
  Eye,
  Loader,
  type LucideProps,
  MessageSquareWarning,
  OctagonAlert,
} from "lucide-react";

type Props = {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  color?: string;
};

export const ReviewedIcon = ({ className }: Props) => {
  return (
    <Circle
      color="#27A544"
      size={22}
      strokeWidth={2.75}
      className={className}
    />
  );
};

export const ProcessingIcon = ({ className }: Props) => {
  return (
    <Loader
      color="#94a2b3"
      size={22}
      strokeWidth={2.75}
      className={cn(className)}
    />
  );
};

export const ExportFailedIcon = ({ className }: Props) => {
  return (
    <OctagonAlert
      size={22}
      strokeWidth={2.75}
      color="#eb5657"
      className={className}
    />
  );
};

export const WarningIcon = ({ ...props }: LucideProps) => {
  return <MessageSquareWarning size={22} {...props} />;
};

export const ToReviewIcon = ({ className }: Props) => {
  return (
    <Eye size={22} strokeWidth={2.75} color="#f2be00" className={className} />
  );
};

export const ExportedIcon = ({ className, color }: Props) => {
  return (
    <CircleCheck
      size={22}
      strokeWidth={2.75}
      color={color ?? "#5f6ad2"}
      className={className}
    />
  );
};

export const ConfirmedIcon = ({ className, color }: Props) => {
  return (
    <CircleCheck
      size={22}
      strokeWidth={2.75}
      color={color ?? "#5f6ad2"}
      className={className}
    />
  );
};
